import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/User/Accounts/Accounts.module.scss'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import PropTypes from 'prop-types'
import { Button } from 'gu-ui-kit'

const Refresh = () => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  return (
    <Button
      component={'a'}
      variant={'ghost'}
      link
      className={styles['accounts__connect-link']}
      href={pathGen(ROUTES.USER_ADMITAD_ATTACH)}
    >
      {t('user::settings.accounts.refresh')}
    </Button>
  )
}

Refresh.propTypes = {
  asButton: PropTypes.bool,
}

export default Refresh
